import Service from '../service.js';

export default {
  data() {
    return {
      financeList: [],
      insuranceList: [],
      tId: '66aaf74f247b9fffdb5eba08'
    };
  },
  created() {
    this.getcompany();
  },
  methods: {

    handClick(url) {
      this.$router.push(url);
    },
    getcompany() {
      Service.getcompany({ tId: this.tId, limit: 'unlimited' }).then(res => {
        const financeList = [];
        const insuranceList = [];
        res.result.forEach(item => {
          if (item.type === 1) {
            financeList.push(item);
          } else if (item.type === 2) {
            insuranceList.push(item);
          }
        });
        this.financeList = financeList;
        this.insuranceList = insuranceList;
      }, () => {
        this.$errorMessage('请求失败');
      });
    }
  }
};

